import Box from "@mui/material/Box";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import isBoolean from "lodash/isBoolean";
import isNumber from "lodash/isNumber";
import { useMemo } from "react";
import Flx from "../../layout/Flx";
import FlxGrid from "../../../_src_shared/components/layout/FlxGrid";

const InputWrapper = ({
  sx,
  fullWidth,
  children,
  helperText,
  bold,
  label,
  labelSx,
  fw,
  required,
  mb,
  mt,
  row,
  helperSx,
}) => {
  const styles = useMemo(() => {
    return {
      ...sx,
      mb: isBoolean(mb) ? 2 : isNumber(mb) ? mb : 0,
      mt: isBoolean(mt) ? 2 : isNumber(mt) ? mt : 0,
    };
  }, [sx, mt, mb]);

  if (row) {
    return (
      <FlxGrid
        width="200px"
        grow={1}
        gap={0.4}
        className={"input-row-root"}
        sx={styles}
      >
        <Flx
          sx={{
            // py: 0.8,
            //
            mr: 2,
          }}
          column
          jc
          //
          className={"input-row-label-root"}
        >
          <InputLabel
            sx={{
              whiteSpace: "normal",
              fontWeight: bold ? "bold" : fw ? fw : "normal",
              marginBottom: row ? 0 : "3px",
              flexShrink: row ? 0 : undefined,
              ...labelSx,
            }}
          >
            {label}
          </InputLabel>
          {helperText ? (
            <FormHelperText
              sx={{ fontStyle: "italic", fontSize: "11px !important", m: 0 }}
            >
              {helperText}
            </FormHelperText>
          ) : null}
        </Flx>
        <Flx end ac className={"input-row-value-root"}>
          {children}
        </Flx>
      </FlxGrid>
    );
  }
  return (
    <Flx
      fw={fullWidth}
      column={!row}
      ac={row}
      gap={row ? 1.5 : 0}
      className={"input-wrapper-root"}
      sx={styles}
    >
      <InputLabel
        sx={{
          whiteSpace: "normal",
          fontWeight: bold ? "bold" : fw ? fw : "normal",
          marginBottom: row ? 0 : "3px",
          flexShrink: row ? 0 : undefined,
          ...labelSx,
        }}
      >
        {label}
        {required ? (
          <Box sx={{ pl: 0.5, display: "inline-block" }}>
            <span style={{ color: "var(--titleColor)" }}>*</span>
          </Box>
        ) : null}
      </InputLabel>
      {row ? <Box sx={{ flex: 1 }}>{children}</Box> : children}
      {helperText ? (
        <FormHelperText
          sx={{ fontStyle: "italic", fontSize: "12px !important", ...helperSx }}
        >
          {helperText}
        </FormHelperText>
      ) : null}
    </Flx>
  );
};

export default InputWrapper;

// import Box from "@mui/material/Box";
// import FormHelperText from "@mui/material/FormHelperText";
// import InputLabel from "@mui/material/InputLabel";
// import isBoolean from "lodash/isBoolean";
// import isNumber from "lodash/isNumber";
// import { useMemo } from "react";
// import Flx from "../../layout/Flx";

// const InputWrapper = ({
//   sx,
//   fullWidth,
//   children,
//   helperText,
//   bold,
//   label,
//   labelSx,
//   fw,
//   required,
//   mb,
//   mt,
// }) => {
//   const styles = useMemo(() => {
//     return {
//       ...sx,
//       mb: isBoolean(mb) ? 2 : isNumber(mb) ? mb : 0,
//       mt: isBoolean(mt) ? 2 : isNumber(mt) ? mt : 0,
//     };
//   }, [sx, mt, mb]);
//   return (
//     <Flx fw={fullWidth} column className={"input-wrapper-root"} sx={styles}>
//       <InputLabel
//         sx={{
//           whiteSpace: "normal",
//           fontWeight: bold ? "bold" : fw ? fw : "normal",
//           marginBottom: "3px",

//           // ---
//           // fontSize: "13px",
//           // fontWeight: 600,
//           // color: "#151720",
//           // marginBottom: "6px",
//           ...labelSx,
//         }}
//       >
//         {label}
//         {required ? (
//           <Box sx={{ pl: 0.5, display: "inline-block" }}>
//             <span style={{ color: "var(--titleColor)" }}>*</span>
//           </Box>
//         ) : null}
//       </InputLabel>
//       {children}
//       {helperText ? (
//         <FormHelperText
//           sx={{ fontStyle: "italic", fontSize: "12px !important"}}
//         >
//           {helperText}
//         </FormHelperText>
//       ) : null}
//     </Flx>
//   );
// };

// export default InputWrapper;
